import { useState } from "react";
import { Icon, Stack, TextField } from "@fluentui/react";
import Send_icon from "../../../../assets/send_message_icon.png";
import Send_icon_white from "../../../../assets/paper-plane.svg";
import Send_icon_active from "../../../../assets/send_message_icon_active.png";
import styles from "./QuestionInput.module.css";
import send_black from "../../../../assets/send_black.svg";

interface Props {
  onSend: (question: string) => void;
  disabled: boolean;
  placeholder?: string;
  clearOnSend?: boolean;
  allowEmpty?: boolean;
}
// TODO replace icon of send and dropdown header, ask icon to Shaymar
export const QuestionInput = ({
  onSend,
  disabled,
  placeholder,
  clearOnSend,
  allowEmpty,
}: Props) => {
  const [question, setQuestion] = useState<string>("");

  const sendQuestion = () => {
    if (disabled || (!allowEmpty && !question.trim())) {
      return;
    }

    onSend(question);

    if (clearOnSend) {
      setQuestion("");
    }
  };

  const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
    if (ev.key === "Enter" && !ev.shiftKey) {
      ev.preventDefault();
      sendQuestion();
    }
  };

  const onQuestionChange = (
    _ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setQuestion(newValue || "");
  };

  return (
    <Stack
      horizontal
      className={`${styles.questionInputContainer} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <input
        type="text"
        className={styles.questionInputTextArea}
        placeholder={placeholder}
        value={question}
        onChange={(e) => onQuestionChange(e, e.target.value)}
        onKeyDown={onEnterPress}
        disabled={disabled}
        style={{
          width: '100%',
          paddingTop: '15px',
          paddingBottom: '15px',
          paddingLeft: '20px',
          paddingRight: '52px',
          outline: 'none',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#5566ff';
          e.target.style.boxShadow = '0 0 0 2px rgba(85, 102, 255, 0.2)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = '#d1d5dc';
          e.target.style.boxShadow = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)';
        }}
      />
      <div
        className={`${styles.questionInputSendButtonContainer} ${
          (question || allowEmpty) ? styles.active : ""
        }`}
        role="button"
        tabIndex={0}
        aria-label="Ask question button"
        onClick={sendQuestion}
        onKeyDown={(e) =>
          e.key === "Enter" || e.key === " " ? sendQuestion() : null
        }
      >
        <img
          src={send_black}
          className={styles.questionInputSendButton}
        />

      </div>
    </Stack>
  );
};
